const domain = 'skipr.eu.auth0.com';
const clientId = process.env.VUE_APP_AUTH_CLIENT_ID as string
const audience = process.env.VUE_APP_API_BASE_URL as string;

export default {
  domain: domain,
  clientId: clientId,
  audience: audience,
};
